import { Link } from '@framework/router/Next/Link';

import styles from './rowLink.module.scss';

interface IRowLinkOverlayProps {
  href: string,
  target?: '_self' | '_blank',
  dataTest?: string,
}

const RowLinkOverlay = ({ href, target = '_self', dataTest = 'linkOverlay' }: IRowLinkOverlayProps) => (
  <Link
    to={ href }
    target={ target }
    rel={ target === '_blank' ? 'noopener noreferrer' : undefined }
    className={ styles.rowLinkOverlay }
    data-test={ dataTest }
    tabIndex={ -1 }
    aria-hidden="true"
  />
);

export default RowLinkOverlay;
